// extracted by mini-css-extract-plugin
module.exports = {"container":"TextUnread_container__yJ09N","unread":"TextUnread_unread__1lh9j"};